import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

export const CATEGORIES = [
  {
    id: "ac",
    icon: "Wind",
    image:
      "https://images.unsplash.com/photo-1762341123870-d706f257a12e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxhaXIlMjBjb25kaXRpb25lciUyMG1vZGVybiUyMGhvbWV8ZW58MHx8fHwxNzg1MjY2NjMxfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "appliances",
    icon: "WashingMachine",
    image:
      "https://images.pexels.com/photos/3829549/pexels-photo-3829549.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "paint",
    icon: "Paintbrush",
    image:
      "https://images.pexels.com/photos/6474471/pexels-photo-6474471.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "windows",
    icon: "DoorOpen",
    image:
      "https://images.unsplash.com/photo-1513584684374-8bab748fbf90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB3aW5kb3dzJTIwaG91c2V8ZW58MHx8fHwxNzg1MjY2NjMxfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "plumbing",
    icon: "Droplets",
    image:
      "https://images.unsplash.com/photo-1595515770330-ceeea7d82cfd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBiYXRocm9vbSUyMHBsdW1iaW5nJTIwc2lua3xlbnwwfHx8fDE3ODUyNjY2MzF8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "pressure",
    icon: "SprayCan",
    image:
      "https://images.unsplash.com/photo-1781637202423-33ec5b47e52e?crop=entropy&cs=srgb&fm=jpg&q=85&w=940&h=650&fit=crop",
  },
  {
    id: "general",
    icon: "Wrench",
    image:
      "https://images.unsplash.com/photo-1645651964715-d200ce0939cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxjYXJwZW50ZXIlMjB0b29scyUyMHJlcGFpcnxlbnwwfHx8fDE3ODUyNjY2MzF8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const FOUNDER_PHOTO =
  "https://customer-assets-0z36b82j.emergentagent.net/job_list-gets-done/artifacts/orardtcc_Foto%20Diana_2.jpeg";

export const translations = {
  en: {
    nav: { how: "How it works", services: "Services", about: "About", book: "Book now" },
    hero: {
      line1: "He meant to fix it.",
      line2: "We actually did.",
      cta: "See what's on your list",
    },
    problem: {
      marquee: "the list that never ends",
      headline: "Every home has one. The list that never ends.",
      body: "The dishwasher that's been 'almost fixed' since spring. The blinds still waiting on that one bracket. The paint touch-up that got postponed for a game day. You've asked. You've reminded. You've given up asking. That list isn't going anywhere on its own. We are.",
    },
    how: {
      title: "How it works",
      steps: [
        { t: "Tell us what's on the list", d: "Pick a category, describe the problem, pick a date." },
        { t: "We send someone who actually shows up", d: 'No "I\'ll get to it eventually."' },
        { t: "Cross it off. For real this time.", d: "Confirmation, done, no follow-up nagging required." },
      ],
    },
    services: {
      title: "Services",
      subtitle: "Seven things off your list. Tap one to start.",
      cta: "Add to the list",
      from: "from",
      items: {
        ac: { name: "AC & Climate", line: "Because 'it's fine' at 85°F is not a personality trait.", price: "$99" },
        appliances: { name: "Appliances", line: "That dishwasher isn't 'basically working.' It's basically not.", price: "$120" },
        paint: { name: "Paint & Walls", line: "The touch-up paint has been in the garage for a year. We know.", price: "$2.99/sq ft" },
        windows: { name: "Windows & Doors", line: "Drafty in January, stuck in July. We fix both seasons.", price: "$150" },
        plumbing: { name: "Plumbing", line: "That drip isn't 'nothing.' It's a water bill.", price: "$50" },
        pressure: { name: "Pressure Washing", line: "The driveway remembers 2019. Let's not.", price: "$80" },
        general: { name: "General Repairs", line: "Not on the list above? It's still on ours.", quote: "Free estimate" },
      },
    },
    about: {
      chapter: "The founder",
      headline: "Started by someone who got tired of asking too.",
      body: "Diana started He Meant To after one too many 'I'll do it this weekend' that turned into next year. Instead of getting mad, she got a team of vetted, reliable pros for every job on the list, dispatched the same way, every time. No more asking twice.",
      caption: "Diana — founder, He Meant To",
    },
    closing: {
      headline: "Your list called. It's tired of waiting.",
      cta: "Book it. Actually.",
    },
    floating: {
      label: "Text us — consider it done",
      text: "Text us",
      whatsapp: "WhatsApp us",
      sms: "Hi He Meant To! I've got something on my list I'd love to cross off.",
    },
    footer: {
      tagline: "He meant to fix it. We actually did.",
      area: "Serving Central Florida & Orlando.",
      rights: "All rights reserved.",
    },
    booking: {
      back: "Back",
      next: "Next",
      submit: "Confirm booking",
      steps: ["Category", "Details", "Date", "Contact", "Done"],
      s1: { title: "What's on the list?", sub: "Pick a category to get started." },
      s2: { title: "Tell us what's going on", sub: "The more we know, the faster we cross it off.", placeholder: "e.g. The dishwasher fills but won't drain...", photo: "Add a photo (optional)", photoAdded: "Photo added", remove: "Remove" },
      s3: { title: "When works for you?", sub: "Pick a day. We'll confirm an arrival window — not an exact minute." },
      s4: { title: "Where do we show up?", sub: "So we can actually get there.", name: "Full name", phone: "Phone", address: "Address", email: "Email" },
      s5: { title: "Consider it done.", sub: "We've got your request. Here's what's booked:", date: "Date", category: "Service", note: "We'll reach out to confirm your arrival window. No follow-up nagging required.", home: "Back to home", another: "Book another" },
      required: "Please fill in the required fields.",
      invalidEmail: "Please enter a valid email address.",
      submitting: "Booking...",
      errorTitle: "Something went wrong",
      errorBody: "We couldn't save your booking. Please try again.",
      pickDate: "Pick a date",
    },
    seo: {
      title: "He Meant To — Handyman Central Florida | Orlando Handyman",
      desc: "He meant to fix it. We actually did. Book a vetted handyman in Central Florida & Orlando — AC, appliances, paint, plumbing, windows, pressure washing & repairs.",
    },
  },
  es: {
    nav: { how: "Cómo funciona", services: "Servicios", about: "Nosotros", book: "Reservar" },
    hero: {
      line1: "Dijo que lo iba a arreglar.",
      line2: "Nosotros sí lo hicimos.",
      cta: "¿Cuál es tu lista de pendientes?",
    },
    problem: {
      marquee: "la lista que nunca se acaba",
      headline: "Toda casa tiene una. La lista de pendientes que nunca se acaba.",
      body: "El lavaplatos que 'casi' se arregló desde la primavera. Las persianas que siguen esperando ese soporte. La pintura pendiente que se pospuso por el partido. Ya lo pediste. Ya se lo recordaste. Ya dejaste de pedirlo. Esa lista no se va a resolver sola. Nosotros sí.",
    },
    how: {
      title: "Cómo funciona",
      steps: [
        { t: "Cuéntanos qué hay en la lista de pendientes", d: "Elige una categoría, describe el problema, elige una fecha." },
        { t: "Enviamos a alguien que sí llega", d: 'Nada de "ya lo voy a hacer".' },
        { t: "Táchalo. Esta vez de verdad.", d: "Confirmación, listo, sin tener que recordarlo de nuevo." },
      ],
    },
    services: {
      title: "Servicios",
      subtitle: "Siete cosas menos en tu lista de pendientes. Toca para empezar.",
      cta: "Agregar a la lista",
      from: "desde",
      items: {
        ac: { name: "Aire Acondicionado", line: "Porque 'está bien así' a 30°C no es una virtud.", price: "$99" },
        appliances: { name: "Electrodomésticos", line: "Ese lavaplatos no está 'más o menos funcionando'. No funciona.", price: "$120" },
        paint: { name: "Pintura y Paredes", line: "La pintura de retoque lleva un año en el garaje. Lo sabemos.", price: "$2.99/pie²" },
        windows: { name: "Ventanas y Puertas", line: "Con corriente en enero, atascada en julio. Arreglamos las dos temporadas.", price: "$150" },
        plumbing: { name: "Plomería", line: "Esa gotera no es 'nada'. Es la factura del agua.", price: "$50" },
        pressure: { name: "Lavado a Presión", line: "La entrada todavía recuerda el 2019. Ya no más.", price: "$80" },
        general: { name: "Reparaciones Generales", line: "¿No está en la lista de arriba? Igual está en la nuestra.", quote: "Cotización gratis" },
      },
    },
    about: {
      chapter: "La fundadora",
      headline: "Fundado por alguien que también se cansó de pedirlo.",
      body: "Diana fundó He Meant To después de escuchar demasiadas veces 'lo hago este fin de semana', que se convertían en el año siguiente. En vez de enojarse, armó un equipo de profesionales confiables y verificados para cada tarea de la lista, asignados siempre de la misma manera. Sin tener que pedirlo dos veces.",
      caption: "Diana — fundadora, He Meant To",
    },
    closing: {
      headline: "Tu lista llamó. Ya se cansó de esperar.",
      cta: "Resérvalo. De verdad.",
    },
    floating: {
      label: "Escríbenos — considéralo hecho",
      text: "Envíanos SMS",
      whatsapp: "WhatsApp",
      sms: "¡Hola He Meant To! Tengo algo en mi lista que me encantaría tachar.",
    },
    footer: {
      tagline: "Dijo que lo iba a arreglar. Nosotros sí lo hicimos.",
      area: "Al servicio de Florida Central y Orlando.",
      rights: "Todos los derechos reservados.",
    },
    booking: {
      back: "Atrás",
      next: "Siguiente",
      submit: "Confirmar reserva",
      steps: ["Categoría", "Detalles", "Fecha", "Contacto", "Listo"],
      s1: { title: "¿Qué hay en la lista?", sub: "Elige una categoría para empezar." },
      s2: { title: "Cuéntanos qué está pasando", sub: "Mientras más sepamos, más rápido lo tachamos.", placeholder: "ej. El lavaplatos se llena pero no drena...", photo: "Agregar una foto (opcional)", photoAdded: "Foto agregada", remove: "Quitar" },
      s3: { title: "¿Cuándo te viene bien?", sub: "Elige un día. Confirmaremos una ventana de llegada — no un minuto exacto." },
      s4: { title: "¿A dónde llegamos?", sub: "Para poder llegar de verdad.", name: "Nombre completo", phone: "Teléfono", address: "Dirección", email: "Correo" },
      s5: { title: "Considéralo hecho.", sub: "Recibimos tu solicitud. Esto es lo reservado:", date: "Fecha", category: "Servicio", note: "Te contactaremos para confirmar tu ventana de llegada. Sin tener que recordarlo de nuevo.", home: "Volver al inicio", another: "Reservar otra" },
      required: "Por favor completa los campos requeridos.",
      invalidEmail: "Por favor ingresa un correo válido.",
      submitting: "Reservando...",
      errorTitle: "Algo salió mal",
      errorBody: "No pudimos guardar tu reserva. Inténtalo de nuevo.",
      pickDate: "Elige una fecha",
    },
    seo: {
      title: "He Meant To — Handyman Orlando | Reparaciones del Hogar Florida Central",
      desc: "Dijo que lo iba a arreglar. Nosotros sí lo hicimos. Reserva un handyman confiable en Florida Central y Orlando — aire, electrodomésticos, pintura, plomería y más.",
    },
  },
};

export const SERVICE_PAGES = {
  en: {
    ac: {
      title: "AC & Climate Repair in Central Florida — He Meant To",
      desc: "Fast, honest AC repair, tune-ups and troubleshooting in Orlando and Central Florida. From $99. He meant to fix it. We actually did.",
      intro: "AC out? Weak airflow? Uneven cooling? We diagnose and fix it fast — before it becomes a $2,000 emergency.",
      body: "From no-cool calls and thermostat swaps to full tune-ups, our vetted techs cover Central Florida homes and small businesses. Same-day slots when available, upfront pricing, and no 'I'll get to it eventually.'",
    },
    appliances: {
      title: "Appliance Repair in Orlando — Dishwasher, Fridge, Washer & Dryer | He Meant To",
      desc: "Appliance repair in Central Florida — dishwashers, fridges, washers, dryers, ovens. From $120. Book online in minutes.",
      intro: "That dishwasher isn't 'basically working.' It's basically not. We diagnose, source parts, and get it running again.",
      body: "Common fixes: dishwashers that fill but don't drain, fridges that stopped cooling, washers that won't spin, dryers that take forever. If it plugs in, we probably fix it — no ten-minute call turning into a two-week wait.",
    },
    paint: {
      title: "Interior Painting & Wall Repair in Central Florida — He Meant To",
      desc: "Interior painting, touch-ups, drywall and wall repair in Orlando & Central Florida. From $2.99/sq ft. Clean tape lines, no drama.",
      intro: "The touch-up paint has been in the garage for a year. We know. Let's actually get it on the wall this weekend.",
      body: "Full rooms, accent walls, ceilings, patch-and-paint after moves and everything in between. We show up on time, tape clean lines, and clean up when we leave. Estimates in minutes, not next week.",
    },
    windows: {
      title: "Window & Door Repair in Central Florida — Sticking, Drafty, Broken Seals | He Meant To",
      desc: "Window and door repair, weatherstripping, hardware, hinges and stuck sliders in Orlando & Central Florida. From $150.",
      intro: "Drafty in January, stuck in July. We fix both seasons — hardware, seals, sliders, hinges and everything in between.",
      body: "From patio-slider tracks that won't glide to doors that swelled shut in summer, we handle the small repairs the big-box installers won't bother with. Real fixes, real fast.",
    },
    plumbing: {
      title: "Handyman Plumbing in Orlando — Leaks, Toilets, Faucets | He Meant To",
      desc: "Small plumbing repairs in Central Florida — leaky faucets, toilets, garbage disposals, shut-off valves. From $50.",
      intro: "That drip isn't 'nothing.' It's a water bill. We stop it before it gets weird.",
      body: "Faucet cartridges, toilet fill valves, running toilets, garbage disposals, shut-off valves and minor drain clears. We handle the calls too small for a big plumbing outfit — same brand, same team, every time.",
    },
    pressure: {
      title: "Pressure Washing in Central Florida — Driveway, House, Roof | He Meant To",
      desc: "Pressure and soft washing for driveways, sidewalks, siding, decks and pool cages in Orlando & Central Florida. From $80.",
      intro: "The driveway remembers 2019. Let's not. We bring the psi and the drop-cloths.",
      body: "Concrete driveways and sidewalks, house siding, patios, fences, pool cages and soft-washing where it matters. We rinse plants, respect your neighbors' cars, and leave the property spotless.",
    },
    general: {
      title: "General Home Repairs in Orlando & Central Florida — He Meant To",
      desc: "The catch-all handyman list — mounting, assembly, small repairs and everything the other guys pass on. Free estimate.",
      intro: "Not on the list above? It's still on ours. TVs, shelves, blinds, doorbells, assemblies, small carpentry — everything on the honey-do list.",
      body: "Free estimate. If we can do it in an afternoon, we probably will. If it needs a specialist, we'll tell you honestly. Either way, no more asking twice.",
    },
  },
  es: {
    ac: {
      title: "Reparación de Aire Acondicionado en Florida Central — He Meant To",
      desc: "Reparación honesta y rápida de aire acondicionado en Orlando y Florida Central. Desde $99. Sin sorpresas ni 'ahorita voy'.",
      intro: "¿AC apagado? ¿Poco frío? ¿Frío desigual? Diagnosticamos y arreglamos rápido — antes de que sea una emergencia de $2,000.",
      body: "Desde llamadas sin frío y cambios de termostato hasta mantenimientos completos, nuestro equipo verificado cubre casas y pequeños negocios en Florida Central. Precios claros, franjas horarias el mismo día cuando hay disponibilidad, sin 'ya lo hago'.",
    },
    appliances: {
      title: "Reparación de Electrodomésticos en Orlando — Lavaplatos, Nevera, Lavadora | He Meant To",
      desc: "Reparación de electrodomésticos en Florida Central — lavaplatos, neveras, lavadoras, secadoras, hornos. Desde $120.",
      intro: "Ese lavaplatos no está 'más o menos funcionando'. No funciona. Lo diagnosticamos, conseguimos la pieza y lo dejamos andando.",
      body: "Arreglos comunes: lavaplatos que se llenan pero no drenan, neveras que dejaron de enfriar, lavadoras que no giran, secadoras eternas. Si se enchufa, probablemente lo reparamos.",
    },
    paint: {
      title: "Pintura Interior y Paredes en Florida Central — He Meant To",
      desc: "Pintura interior, retoques y reparación de paredes en Orlando y Florida Central. Desde $2.99/pie². Sin drama.",
      intro: "La pintura de retoque lleva un año en el garaje. Lo sabemos. Vamos a ponerla en la pared este fin de semana.",
      body: "Cuartos completos, paredes de acento, techos, parcheo y pintura después de mudanzas y todo lo intermedio. Llegamos a tiempo, dejamos líneas limpias con cinta y todo ordenado al terminar. Estimados en minutos.",
    },
    windows: {
      title: "Reparación de Ventanas y Puertas en Florida Central — He Meant To",
      desc: "Reparación de ventanas y puertas, sellado, herrajes, bisagras y correderas atascadas en Orlando y Florida Central. Desde $150.",
      intro: "Con corriente en enero, atascada en julio. Arreglamos las dos temporadas — herrajes, sellos, correderas, bisagras.",
      body: "Desde correderas de patio que no deslizan hasta puertas que se hincharon en verano, nos encargamos de los arreglos pequeños que los grandes instaladores ignoran. Rápido y bien hecho.",
    },
    plumbing: {
      title: "Plomería de Handyman en Orlando — Fugas, Baños, Grifos | He Meant To",
      desc: "Reparaciones menores de plomería en Florida Central — grifos con fuga, sanitarios, trituradores, llaves de paso. Desde $50.",
      intro: "Esa gotera no es 'nada'. Es la factura del agua. Se detiene antes de que se ponga rara.",
      body: "Cartuchos de grifos, válvulas de sanitario, sanitarios que corren, trituradores de basura, llaves de paso y destapes menores. Cubrimos las llamadas demasiado pequeñas para plomerías grandes — misma marca, mismo equipo, siempre.",
    },
    pressure: {
      title: "Lavado a Presión en Florida Central — Entrada, Casa, Techo | He Meant To",
      desc: "Lavado a presión y lavado suave para entradas, aceras, fachadas, terrazas y jaulas de piscina en Orlando y Florida Central. Desde $80.",
      intro: "La entrada todavía recuerda el 2019. Ya no más. Traemos la presión y las lonas.",
      body: "Entradas y aceras de concreto, fachadas, patios, cercas, jaulas de piscina y lavado suave donde hace falta. Enjuagamos las plantas, cuidamos los carros del vecino y dejamos todo impecable.",
    },
    general: {
      title: "Reparaciones Generales del Hogar en Orlando y Florida Central — He Meant To",
      desc: "Todo-en-uno: montaje, ensamblaje, arreglos pequeños y todo lo que otros no aceptan. Cotización gratis.",
      intro: "¿No está en la lista de arriba? Igual está en la nuestra. TVs, estantes, persianas, timbres, ensamblajes, carpintería menor — todo el 'hazlo pronto'.",
      body: "Cotización gratis. Si se puede hacer en una tarde, probablemente lo hacemos. Si necesita un especialista, te lo decimos honestamente. Sin pedirlo dos veces.",
    },
  },
};

const LanguageContext = createContext(null);

function detectLang() {
  try {
    const params = new URLSearchParams(window.location.search);
    const q = params.get("lang");
    if (q === "en" || q === "es") return q;
    const saved = localStorage.getItem("hmt_lang");
    if (saved === "en" || saved === "es") return saved;
    const nav = (navigator.language || "en").toLowerCase();
    return nav.startsWith("es") ? "es" : "en";
  } catch {
    return "en";
  }
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(detectLang);

  useEffect(() => {
    try {
      localStorage.setItem("hmt_lang", lang);
    } catch {
      /* ignore storage errors */
    }
    document.documentElement.lang = lang === "es" ? "es-US" : "en-US";
  }, [lang]);

  const toggle = useCallback((next) => setLang(next), []);

  return (
    <LanguageContext.Provider value={{ lang, setLang: toggle, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
